// import React from 'react';
// import PropTypes from 'prop-types';
// import { InputGroup } from 'react-bootstrap';
import SimpleText from './simple-text';

const validations = ['email'];
class EmailText extends SimpleText {
  constructor (props) {
    super(props);
    const self = this;
    self.defineValidations(validations);
    self.state = self.state || {};
    self.state.type = 'email';
  }
}
export default EmailText;
